import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useSelector } from 'react-redux';
import { mapFieldValues } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';
import useFilteredData from '../../template/tableV2/FilterFunction';
import { createFetchDataServer } from '../../../database/fetchData';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const BurialsHome = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableBurials.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([]);
      setTitle(`חיפוש כללי`);
    } else {
      setBreadcrumbs([]);
      setTitle(`נפטרים`);
    }
  }, [location.pathname]);

  // מטפל בפורמט תאריכים
  function formatDate(dateString) {
    if (!dateString || dateString === '0000-00-00') {
      return ''; // מחזיר מחרוזת ריקה אם התאריך הוא לא תקין
    }

    // בודק אם התאריך מכיל פרטים נוספים (למשל T00:00:00.000Z)
    const cleanDateString = dateString.includes('T') ? dateString.split('T')[0] : dateString;

    const [year, month, day] = cleanDateString.split('-');
    return `${day}/${month}/${year}`;
  }
  const mappedData = mapFieldValues(context?.contextBurials, optionsFields);
  // ?.map(temp => {
  //   return {...temp, reportingBL: formatDate(temp?.reportingBL), dateOpening: formatDate(temp?.dateOpening)}
  // })
  // שימוש בפונקציה החיצונית לסינון הנתונים

  const filteredData = useFilteredData(mappedData, searchText);

  const handleRowClick = (row) => {
    if (location.pathname.endsWith('globalSearch')) {
      navigate('/burial'); // משנה את הניווט לנתיב '/block'
    }

    let temp = context?.contextGraves?.find((g) => g.unicId === row[0]?.graveId)?.areaGraveId;

    navigate(`/areaGrave/${temp}`, {
      state: {
        value: context?.contextAreaGraves?.find((ag) => ag.unicId === temp)
      }
    });
  };

  const onPageChange = (item) => {
    console.log(item);
  };

  const onRowsPerPageChange = (item) => {
    console.log(item);
  };

  return (
    <>
      {loading && <p>Loading...</p>}
      <PaymentsManagementExample columns={columns.filter((prop) => prop.show)} defaultRows={filteredData} searchText={filteredData} onRowSelect={handleRowClick} currentPage={currentPage} rowsPerPage={rowsPerPage} onPageChange={onPageChange} onRowsPerPageChange={onRowsPerPageChange} defaultHeight={'1000px'} />
    </>
  );
};

export default BurialsHome;
